import React, { useState } from 'react';

// Styles & Assets
import styles from './SelectableItems.module.css';

// Hooks
import { useTranslation } from 'react-i18next';

// Components
import Searchbar from '../../UI/Searchbar/Searchbar';
import SelectorZonesBed from '../SelectorZonesBed/SelectorZonesBed';
import ErrorSpinnerWrapper from '../../UI/ErrorSpinnerWrapper.tsx/ErrorSpinnerWrapper';

// Interfaces
import { Bed, ITown } from '../../../interfaces/Patient';
import { Profile } from '../../../interfaces/Profile';
import { ActionReducerZoneAdministration } from '../../../interfaces/Administration';
interface Props {
    profile: Profile | null
    selectedItemsIDs: (Bed | ITown)['id'][],
    items: (Bed | ITown)[]
    loading: boolean,
    error: string | null
    dispatchSelectedItems: React.Dispatch<ActionReducerZoneAdministration>
}

const SelectableItems: React.FC<Props> = ({ profile, selectedItemsIDs, items, loading, error, dispatchSelectedItems }) => {

    const { t } = useTranslation();

    const [filterText, setFilterText] = useState('');


    const handleSelect = (item: Bed | ITown) => {
        if (profile === null || profile.zone_by_bed === null) return;
        dispatchSelectedItems({ type: profile.zone_by_bed === true ? 'ADD_BEDS' : 'ADD_TOWNS', payload: item.id });
    };

    const handleChangeFilter = (evt: React.ChangeEvent<HTMLInputElement>) => setFilterText(evt.target.value);

    const filterItems = (items: (Bed | ITown)[]) =>
        items.filter(i => i.name?.toLocaleLowerCase().includes(filterText.toLocaleLowerCase()));

    const itemsToBlock = profile?.zone_by_bed === true ?
        items.filter(b => b.zone_id !== null && b.zone_id !== undefined).map(b => b.id) : [];

    return (
        <div className={styles.optionsSelectorContainer}>
            <div className={styles.optionsSelector}>
                {profile === null ? null :
                    <>
                        <div className={styles.optionsSelectorTopRow}>
                            <h2>{profile.zone_by_bed ? t('beds') : t('towns')}</h2>
                        </div>
                        <Searchbar handleChange={handleChangeFilter} />
                        <div className={styles.optionsSelectorBottomRow}>
                            <ErrorSpinnerWrapper
                                loading={loading}
                                error={error}
                            >
                                <SelectorZonesBed
                                    itemsToBlock={itemsToBlock}
                                    selectedItemsIDs={selectedItemsIDs}
                                    items={filterItems(items)}
                                    classButton={styles.buttonSelectorRight}
                                    handleSelect={(item: Bed | ITown) => handleSelect(item)}
                                />
                            </ErrorSpinnerWrapper>
                        </div>
                    </>
                }
            </div>
        </div>
    );
};

export default SelectableItems;